import { useEffect } from "react";

export const SITE_URL = "https://myschoolmate.net";
const DEFAULT_TITLE = "MySchoolMate — Cari & Bandingkan Sekolah untuk Anak";
const DEFAULT_DESCRIPTION =
  "Cari dan bandingkan sekolah berdasarkan lokasi, biaya, kurikulum, fasilitas, dan kebutuhan anak. Temukan pilihan yang lebih sesuai lewat MySchoolMate.";
const DEFAULT_IMAGE = `${SITE_URL}/assets/landing/3people.png`;

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO({
  title,
  description,
  canonical,
  canonicalPath,
  image,
  type = "website",
  noIndex = false,
  jsonLd = null,
}) {
  const fullTitle = title || DEFAULT_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const url = canonical || `${SITE_URL}${canonicalPath || "/"}`;
  const img = image || DEFAULT_IMAGE;
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("name", "robots", noIndex ? "noindex, nofollow" : "index, follow");
    upsertLink("canonical", url);

    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", "MySchoolMate");
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", img);

    const existing = document.getElementById("seo-jsonld");
    if (existing) existing.remove();
    if (jsonLdString) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "seo-jsonld";
      script.text = jsonLdString;
      document.head.appendChild(script);
    }
  }, [fullTitle, desc, url, img, type, noIndex, jsonLdString]);

  return null;
}
